import React from 'react'
import { useBestOf2024 } from 'components/BestOf/BestOfUtils'

import BestOfHomePage from './BestOfHomePage'
import HomePageContent from './HomePageContent'

function HomePage() {
  const bestOfConfig = useBestOf2024()
  if (bestOfConfig.enabled || bestOfConfig.wave === 'first-wave-early-access') {
    return <BestOfHomePage />
  }
  return <HomePageContent />
}

export default HomePage
